<template>
    <div class="section accordion-section">
        <b-loading :is-full-page="false" :active="loading"></b-loading>
        <h3 @click.prevent="toggleAccordion" class="subtitle is-flex is-align-items-center is-justify-content-space-between">
            <span v-text="title"></span>
            <b-icon icon="chevron-down"></b-icon>
        </h3>
        <div class="accordion-content" :class="{'is-hidden': !open}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            required: true,
            type: String
        },
        startOpen: {
            required: false,
            type: Boolean,
            default: false
        },
        loading: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false
        }
    },
    mounted() {
        this.open = this.startOpen;
    },
    methods: {
        toggleAccordion() {
            this.open = !this.open;
            this.$emit('toggle', this.open)
        }
    }
}
</script>